"use client"

import Script from "next/script"
import { usePathname, useSearchParams } from "next/navigation"
import { useEffect, Suspense } from "react"

function GoogleAnalyticsEvents({ gaId }: { gaId: string }) {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (pathname) {
      const url = pathname + (searchParams?.toString() ? `?${searchParams.toString()}` : "")
      // @ts-ignore
      if (typeof window !== "undefined" && typeof window.gtag !== "undefined") {
        // @ts-ignore
        window.gtag("config", gaId, {
          page_path: url,
        })
      }
    }
  }, [pathname, searchParams, gaId])

  return null
}

export function GoogleAnalytics({ gaId }: { gaId: string }) {
  if (!gaId) return null

  return (
    <>
        {/*
          Global Site Tag (gtag.js) - Google Analytics
          This will track basic page views and sessions across all domains out of the box.

          Strategies are intentionally split (see diagnostics/2026-05-08 item 3a):
          - External gtag/js: `lazyOnload` — moves the ~470 KB library off the
            FCP critical path (was ~3.5 s mobile-blocking on slow 4G).
          - Inline init: `afterInteractive` — runs early, defines `gtag()` as a
            dataLayer pusher and fires the initial `config` call. All gtag calls
            queue in `window.dataLayer` and are replayed by the library after it
            loads, so no events are lost — only delayed by 1–3 s on cold load.
        */}
      <Script strategy="lazyOnload" src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`} />
      <Script
        id="google-analytics"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            window.dataLayer = window.dataLayer || [];
            function gtag(){window.dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
            });
          `,
        }}
      />
      <Suspense fallback={null}>
        <GoogleAnalyticsEvents gaId={gaId} />
      </Suspense>
    </>
  )
}
